<h2 i18n>Components</h2>

<p i18n>Use this space to develop your view components.</p>
